import ReactMarkdown from "react-markdown";

import { PageHero } from "@/components/layout/PageHero";
import type { LegalDoc } from "@/content/legal";
import type { Locale } from "@/i18n/locales";

type LegalViewProps = {
  locale: Locale;
  doc: LegalDoc;
};

export function LegalView({ doc }: LegalViewProps) {
  return (
    <main className="bg-background">
      <PageHero eyebrow={doc.updated} title={doc.title} />
      <article className="mx-auto max-w-3xl px-5 pb-24">
        <div className="markdown-content rounded-2xl border border-border bg-white p-7 shadow-sm md:p-10">
          <ReactMarkdown>{doc.markdown}</ReactMarkdown>
        </div>
      </article>
    </main>
  );
}
